import { Preference } from '../cookie-consent.types'
import {
  advertisingScriptList,
  essentialCinchScriptsList,
} from '../scripts-config'

// Setup preferences object which constructs the data in the cookie prefs modal
export const setupPreferences = () => {
  const preferences: Preference[] = [
    {
      title: 'Analytics',
      category: 'Analytics',
      purpose: `These cookies help us understand how visitors use our site. They collect anonymous data on page views, traffic sources, and user interactions so we can measure performance and improve the overall experience.
          \nE.g. Adobe Analytics, Adobe Target.`,
      tools: [],
    },
    {
      title: 'Advertising and Targeting',
      category: 'Advertising',
      purpose: `To personalise and measure the effectiveness of advertising on our site and other websites.
          \nAccepting advertising means your data (including anonymous IDs or other encrypted identifiers) may be shared with the third parties specified below. We also use technologies such as web beacons and tracking pixels to allow this to happen.
          \nE.g. Google, Facebook, Adalyser.`,
      tools: [],
    },
    {
      title: 'Essential',
      category: null,
      purpose:
        'We use browser cookies that are necessary for the site to work as intended. For example, we store your website data collection preferences so we can honour them if you return to our site, and track sales so that rewards/cashback sites can recognise a sale has occurred. You can disable these cookies in your browser settings but if you do the site may not work as intended.',
      tools: [essentialCinchScriptsList],
    },
  ]

  // Adds the cinch script names (scripts-config.ts) into the modal's category preferences
  advertisingScriptList.forEach((scriptName: string) => {
    const name = scriptName.includes('MediaCom') ? 'MediaCom' : scriptName
    scriptName &&
      preferences?.[2]?.tools?.includes(name) &&
      preferences?.[2]?.tools?.push(name)
  })

  return preferences
}
